import { useLocation } from "react-router-dom";
import MainContent from "../../../components/mainContent/MainContent"
import { JustificarMinutaDetalleContent } from "./JustificarMinutaDetalleContent"

export const JustificarMinutaDetalle = () => {
    const location = useLocation();
    const { allowedWrite, dataRegistro, idDelegacion, delegacion } = location.state; 
    
    return (
        <MainContent
            component={<JustificarMinutaDetalleContent                 
                allowedWrite={allowedWrite}
                dataRegistro={dataRegistro} 
                idDelegacion={idDelegacion}
                delegacion={delegacion}
            />}
            titulo={"Visualización de Minuta"}
            noBackground
            tableMaxWidth
        />
    )    
}